export function buildPressSheetDownloadHtml(pressUrl, portraitUrl, canvasRebelUrl) {
  return `<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>Love Quetee / Press Sheet</title>
  <style>
    :root {
      color-scheme: light;
      --paper: #fffdf9;
      --wash: #f7f0e6;
      --ink: #1b3d2b;
      --soft-ink: #536154;
      --rose: #91475d;
      --line: rgba(27, 61, 43, 0.22);
    }
    * { box-sizing: border-box; }
    @page { size: letter; margin: 0.45in 0.55in; }
    body {
      margin: 0;
      background: var(--paper);
      color: var(--ink);
      font-family: Arial, Helvetica, sans-serif;
      font-size: 10.5px;
      line-height: 1.34;
    }
    .sheet {
      width: min(100%, 816px);
      margin: 0 auto;
      padding: 1.6rem 0 1.8rem;
    }
    .sheet-header {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 18rem;
      gap: 1.8rem;
      align-items: start;
      padding: 1.35rem 1.45rem 1.15rem;
      background: var(--wash);
      border-bottom: 2px solid var(--ink);
    }
    .eyebrow,
    h2,
    .label,
    .contact dt,
    .footer {
      font-family: Arial, Helvetica, sans-serif;
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }
    .eyebrow {
      color: var(--rose);
      font-size: 0.58rem;
      font-weight: 700;
    }
    h1 {
      margin: 0.45rem 0 0;
      font-family: Georgia, "Times New Roman", serif;
      font-size: 4.15rem;
      font-weight: 400;
      letter-spacing: -0.075em;
      line-height: 0.78;
    }
    .subtitle {
      margin: 0.85rem 0 0;
      color: var(--soft-ink);
      font-family: Georgia, "Times New Roman", serif;
      font-size: 0.78rem;
    }
    .portrait {
      display: block;
      width: 100%;
      height: 8.8rem;
      object-fit: cover;
      object-position: center 44%;
      background: #efe3d8;
    }
    .contact-column { display: grid; gap: 0.8rem; }
    .contact {
      display: grid;
      grid-template-columns: 4.25rem minmax(0, 1fr);
      gap: 0.3rem 0.5rem;
      margin: 0;
      padding: 0.85rem 0 0.85rem 1rem;
      border-left: 1px solid var(--line);
    }
    .contact dt { font-size: 0.5rem; font-weight: 700; }
    .contact dd { margin: 0; color: var(--soft-ink); overflow-wrap: anywhere; }
    .contact a { color: inherit; }
    .contact .social { font-size: 0.61rem; white-space: nowrap; }
    .rule {
      height: 0.4rem;
      border-bottom: 1px solid var(--ink);
    }
    .lede {
      max-width: 42rem;
      margin: 1.1rem 0 0;
      color: var(--soft-ink);
      font-family: Georgia, "Times New Roman", serif;
      font-size: 0.9rem;
    }
    .sheet-grid {
      display: grid;
      grid-template-columns: 0.88fr 1.12fr;
      gap: 1.7rem;
      margin-top: 1.35rem;
    }
    section { break-inside: avoid; page-break-inside: avoid; }
    section + section { margin-top: 1.25rem; }
    h2 {
      margin: 0 0 0.5rem;
      padding-bottom: 0.28rem;
      border-bottom: 1px solid var(--line);
      color: var(--rose);
      font-size: 0.57rem;
      font-weight: 700;
    }
    .practice {
      display: grid;
      gap: 0.38rem;
      margin: 0;
      padding: 0;
      list-style: none;
      color: var(--soft-ink);
      font-family: Georgia, "Times New Roman", serif;
      font-size: 0.78rem;
    }
    .practice li::before { content: "—  "; color: var(--rose); }
    .entry {
      display: grid;
      grid-template-columns: 3.9rem minmax(0, 1fr);
      gap: 0.55rem;
      padding: 0.35rem 0;
      border-bottom: 1px solid rgba(27, 61, 43, 0.13);
    }
    .date {
      color: var(--soft-ink);
      font-size: 0.61rem;
      font-variant-numeric: tabular-nums;
      white-space: nowrap;
    }
    .title { display: block; font-weight: 700; }
    .detail { display: block; color: var(--soft-ink); }
    .awards {
      display: grid;
      gap: 0.35rem;
      margin: 0;
      padding: 0;
      list-style: none;
      color: var(--soft-ink);
    }
    .awards li { padding-bottom: 0.3rem; border-bottom: 1px solid rgba(27, 61, 43, 0.13); }
    .press-link { color: var(--rose); font-weight: 700; }
    .footer {
      margin-top: 1.35rem;
      padding-top: 0.5rem;
      border-top: 1px solid var(--line);
      color: var(--soft-ink);
      font-size: 0.48rem;
    }
    @media (max-width: 680px) {
      .sheet { padding-top: 0.5rem; }
      .sheet-header { grid-template-columns: 1fr; gap: 1rem; }
      .contact { border-top: 1px solid var(--line); border-left: 0; padding: 0.85rem 0 0; }
      .sheet-grid { grid-template-columns: 1fr; gap: 1.2rem; }
    }
    @media print {
      body { background: #fff; }
      .sheet { width: 100%; padding: 0; }
      a { color: inherit; text-decoration: none; }
    }
  </style>
</head>
<body>
  <main class="sheet">
    <header class="sheet-header">
      <div>
        <div class="eyebrow">Press sheet / 2026</div>
        <h1>Love<br>Quetee</h1>
        <p class="subtitle">Fine artist / contemporary painter</p>
      </div>
      <div class="contact-column">
        <img class="portrait" src="${portraitUrl}" alt="Love Quetee in the studio" />
        <dl class="contact">
        <dt>Based:</dt><dd>Maple Grove, Minnesota</dd>
        <dt>Email:</dt><dd><a href="mailto:love.quetee@gmail.com">love.quetee@gmail.com</a></dd>
        <dt>Instagram:</dt><dd class="social"><a href="https://www.instagram.com/loves_artpage">instagram.com/loves_artpage</a></dd>
        <dt>Website:</dt><dd><a href="https://lovequetee.gallery">lovequetee.gallery</a></dd>
        </dl>
      </div>
    </header>
    <div class="rule" aria-hidden="true"></div>

    <p class="lede">Liberian-born and Minnesota-based, Love Quetee’s practice explores Black and African identity, cultural memory, belonging, and the relationship between the human body and the natural world.</p>

    <div class="sheet-grid">
      <div>
        <section>
          <h2>Studio practice</h2>
          <ul class="practice">
            <li>Oil, acrylic, and colored pencil painting</li>
            <li>Realistic portraiture and figure drawing/painting</li>
            <li>Collaborative and community-based art projects</li>
            <li>Art education and workshops</li>
            <li>Environmental and social themes in art</li>
          </ul>
        </section>
        <section>
          <h2>Selected recognition</h2>
          <ul class="awards">
            <li>Weisman Art Museum Award / Gbanganla</li>
            <li>North Hennepin Community College Award of Excellence / In memory of Lance Kiland</li>
            <li>Minnesota Museum of American Art Purchase Award / Gbanganla</li>
          </ul>
        </section>
        <section>
          <h2>Press</h2>
          <p><a class="press-link" href="${pressUrl}">Love in War</a><br><span class="detail">Mankato Free Press</span></p>
          <p><a class="press-link" href="${canvasRebelUrl}">Meet Love Quetee</a><br><span class="detail">Canvas Rebel</span></p>
        </section>
      </div>

      <div>
        <section>
          <h2>Selected exhibitions</h2>
          <div class="entry"><div class="date">2026</div><div><span class="title">Minnesota State Fair Fine Art Exhibition</span></div></div>
          <div class="entry"><div class="date">2025</div><div><span class="title">Juried Show “Value of Nature”</span><span class="detail">Silverwood Park, MN</span></div></div>
          <div class="entry"><div class="date">2025</div><div><span class="title">“Rhythms of West Africa”</span><span class="detail">Artist Talk Show &amp; Workshop Lead</span></div></div>
          <div class="entry"><div class="date">2024</div><div><span class="title">“Memories and Migrations”</span><span class="detail">Solidarity Street Art Gallery, St. Paul, MN</span></div></div>
          <div class="entry"><div class="date">2023</div><div><span class="title">Solo Show: “Ghetto Visionary”</span><span class="detail">Mankato, MN</span></div></div>
        </section>
        <section>
          <h2>Selected projects</h2>
          <div class="entry"><div class="date">2025</div><div><span class="title">Art-A-Whirl</span><span class="detail">Minneapolis / Art Festival at A-Mills Artist Lofts, MN</span></div></div>
          <div class="entry"><div class="date">2025</div><div><span class="title">Afro Artivism Event</span><span class="detail">Commissioned Live Painting / Vanderbilt University, TN</span></div></div>
          <div class="entry"><div class="date">2024</div><div><span class="title">Arts Advocacy Rally</span><span class="detail">Live Painting / Minnesota Citizens for the Arts, MN State Capitol</span></div></div>
        </section>
        <section>
          <h2>Upcoming</h2>
          <div class="entry"><div class="date">2026</div><div><span class="title">Descendants of the Sun</span><span class="detail">November 7, 2026 / African Museum, Arts and Culture Center / Saint Paul, Minnesota</span></div></div>
        </section>
      </div>
    </div>
    <footer class="footer">Love Quetee / artist press sheet</footer>
  </main>
</body>
</html>`;
}
